<template>
    <div id="app">
        <div class="selected-fridge">
            Выбран холодильник: {{fridge}}
        </div>

        <div v-if="!isHomePage">
            <main-menu-button to="/">
                В меню
            </main-menu-button>
        </div>

        <router-view/>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import MainMenuButton from "./components/MainMenuButton";


    export default {
        name: "App",
        components: {MainMenuButton},
        computed: {
            ...mapGetters('app', {
                fridgeId: 'fridgeId',
            }),
            isHomePage() {
                return this.$route.name == 'home';
            },
            fridge() {
                return this.fridgeId ? this.fridgeId : 'не выбран';
            },
        },
        methods: {
            ...mapActions('app', {
                clearLastError: 'clearLastError',
            }),
        },
        mounted() {
            this.clearLastError();
        },
    }
</script>

<style scoped>
    .selected-fridge {
        margin: 20px;
        text-align: center;
    }
</style>
